"use strict";

var QueryString = require("qs"); // https://github.com/hapijs/qs
var _ = require("underscore");


var UrlUtil = {

    /**
     * parse query string and return only fields specified in whitelist array
     * @param  {String} queryString
     * @param  {Array of Strings} whiteList
     * @return {Object}
     */
    parseQueryString: function(query_string, white_list) {
        var qs_obj = QueryString.parse(query_string);
        var qs_obj_filtered = _.pick(qs_obj, white_list);
        return qs_obj_filtered;
    },

    /**
     * generate query string based on fields specified in whithelist array
     * @param  {Object} obj
     * @param  {Array of Strings} whiteList
     * @return {String}          an url query string
     */
    generateQueryString: function(obj, white_list) {
        var qs = QueryString.stringify(obj, {
            filter: function(prefix, value) {
                prefix = prefix.split("[")[0];
                if (prefix === "") {
                    return value;
                } else {
                    if (white_list.indexOf(prefix) != -1) {
                        if (value) // ignore 0, null and ""
                            return value;
                        else
                            return;
                    } else {
                        return;
                    }
                }
            }
        });
        return qs;
    },

    /**
     * Generate a facebook share link
     * @param  {String} app_id  see https://developers.facebook.com/
     * @param  {Object} options display + caption + description + link + redirect_uri + picture (see https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4)
     * @return {String}         can be used in a new page with window.open(url_share, "_blank");
     */
    shareFacebook: function(app_id, options) {
        var url_share = "https://www.facebook.com/dialog/feed?app_id=" + app_id;

        _.each(
            options,
            function(value, key) {
                url_share += "&" + key + "=" + encodeURIComponent(value);
            }
        );

        return url_share;
    },

    /**
     * Generate a twitter share link : https://dev.twitter.com/web/tweet-button/web-intent
     * @param  {String} message
     * @param  {String} link
     * @return {String}             can be used in a new page with window.open(url_share, "_blank");
     */
    shareTwitter: function(message, link, via) {
        return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(link) + "&text=" + encodeURIComponent(message) + "&via=" + encodeURIComponent(via);
    },

    /**
     * transforme une string en une url lisible en ascii
     * @param  {String} str [description]
     * @return {String}     [description]
     */
    slugify: function(str) {

        if (!str) {
            return "";
        }

        var i, ch, pos, new_str = "";

        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        // on met les caractères les plus courants au début

        var fr = "'èéêôçîûàïáäâëìíòóöùúüñ,";
        var to = "-eeeociuaiaaaeiiooouuun-";

        for (i = 0; i < str.length; i++) {
            ch = str.charAt(i);
            pos = fr.indexOf(ch);
            new_str += (pos == -1) ? ch : to.charAt(pos);
        }

        new_str = new_str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return new_str;
    },

    /**
     * update or create meta tag in head.
     * @param {String} attr
     * @param {String} value
     * @param {String} content
     */
    meta: function(attr, value, content) {
        var meta = document.head.querySelector("[" + attr + "='" + value + "']");
        if (meta) {
            meta.content = content;
        } else {
            meta = document.createElement("meta");
            meta.setAttribute(attr,value);
            meta.content = content;
            document.head.appendChild(meta);
        }
    }



};

module.exports = UrlUtil;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/common/utils/url-util.js
// module id = 71
// module chunks = 0